import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarRangeIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { EventCard } from '../../components/member/EventCard';
import { Card } from '../../components/ui/Card';
import type { EventType } from '../../types';
import { organizacijskiTipi } from '../../utils/labels';
type FilterKey = 'vsi' | 'vaje' | 'nastopi' | 'organizacijsko';
const filtri: {
  key: FilterKey;
  label: string;
  tipi?: EventType[];
}[] = [{
  key: 'vsi',
  label: 'Vsi'
}, {
  key: 'vaje',
  label: 'Vaje',
  tipi: ['vaja', 'intenzivna', 'sekcijska', 'generalka']
}, {
  key: 'nastopi',
  label: 'Nastopi',
  tipi: ['nastop']
}, {
  key: 'organizacijsko',
  label: 'Organizacijsko',
  tipi: organizacijskiTipi
}];
export function MemberEvents() {
  const {
    currentMember,
    upcoming,
    visibleEvents,
    getRsvp,
    isExpected
  } = useApp();
  const [filter, setFilter] = useState<FilterKey>('vsi');
  const me = currentMember!;
  const seznam = useMemo(() => {
    const mine = visibleEvents(me.id).filter(e => upcoming.some(u => u.id === e.id));
    const izbran = filtri.find(f => f.key === filter);
    return izbran?.tipi ? mine.filter(e => izbran.tipi!.includes(e.type)) : mine;
  }, [visibleEvents, upcoming, me.id, filter]);
  return <div className="space-y-5" data-id="element-1527" data-mp="2uls35eh4jajp">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-1528" data-mp="2ukqh6eykl3n7">
        <div data-id="element-1529" data-mp="2gun002ejs04m">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-1530" data-mp="2gu4wckpk2jmo">Dogodki</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1531" data-mp="2lm542zbvagtt">
            Vaje, sekcijske vaje, generalke in nastopi, ki se nanašajo na vas.
          </p>
        </div>
        <Link to="/clan/koledar" className="inline-flex items-center gap-2 rounded-lg border border-line bg-white px-3 py-2 text-[13px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-1532" data-mp="26unukedfcpvz">
          <CalendarRangeIcon className="h-4 w-4" data-id="element-1533" data-mp="22vf017ak8nzd" />
          Koledarski pogled
        </Link>
      </div>

      <div className="flex flex-wrap gap-2" data-id="element-1534" data-mp="8f6s8q3amz4j">
        {filtri.map(f => <button key={f.key} onClick={() => setFilter(f.key)} aria-pressed={filter === f.key} className={`rounded-lg border px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 ease-out ${filter === f.key ? 'border-green-500 bg-green-500 text-white' : 'border-line bg-white text-ink-muted hover:bg-canvas hover:text-ink'}`} data-id="element-1535" data-mp="3ognnf2oz0aw">
            {f.label}
          </button>)}
      </div>

      {seznam.length === 0 ? <Card className="p-10 text-center" data-id="element-1536" data-mp="ib9v5y5yz1sj">
          <p className="text-sm font-medium text-ink" data-id="element-1537" data-mp="de9y2cr3l9dk">Za izbrani filter ni dogodkov.</p>
          <p className="mt-1 text-[13px] text-ink-muted" data-id="element-1538" data-mp="333c0xdues8af">Poskusite z drugim tipom dogodka.</p>
        </Card> : <div className="space-y-2.5" data-id="element-1539" data-mp="2y3pmj12ugm01">
          {seznam.map(e => <EventCard key={e.id} event={e} rsvp={getRsvp(e.id)} to={`/clan/dogodki/${e.id}`} expected={isExpected(e, me.id)} data-id="element-1540" data-mp="1dm6otqh8fdaw" />)}
        </div>}
    </div>;
}